import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, catchError, throwError } from 'rxjs';
import { AppService } from 'src/app/service/app.service';

import { DatatableService } from 'src/app/service/datatable.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
declare var $: any;
pdfMake.vfs = pdfFonts.vfs;

@Component({
  selector: 'app-register-master',
  templateUrl: './register-master.component.html',
  styleUrls: ['./register-master.component.css']
})
export class RegisterMasterComponent implements OnInit, OnDestroy {
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  responseData: any = [];
  registerToken: String = "";

  constructor(
    private toastr: ToastrService,
    private titleService: Title,
    private cdref: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private appService: AppService,
    private dataTableService: DatatableService,
  ) {
    this.route.queryParams.subscribe(params => {
    if (params['registerToken']) {
      this.registerToken = params['registerToken'];
    }
  }); }

  ngOnInit(): void {
    this.getRegMaster();
  }

  getRegMaster() {
    let requestObject = {
      emailId: localStorage.getItem("username"),
      token: this.registerToken
    }
    this.appService.fetchRegisterMaster(requestObject).pipe(catchError((error: any) => {
      this.responseData = [];
      this.dataTableService.setDatatable("registerMaster", 8, 10, [10, 25, 50, 100]);
      if (error.status != 200) {
        return throwError(error.error);
      }
    })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        // this.entityList = response.data.entityList;
        this.responseData = response.data[0];
        this.appService.addAuthorisedPerson(this.responseData);
        this.dataTableService.setDatatable("registerMaster", 8, 10, [10, 25, 50, 100]);
      } else {
        this.responseData = [];
        this.dataTableService.setDatatable("registerMaster", 8, 10, [10, 25, 50, 100]);
        this.toastr.warning(response.message);
      }
    });
  }


  open(id: number) {
    this.router.navigate(['/registeruser/register'], { queryParams: { id: id, 'registerToken': this.registerToken } });
  }

  editUserAccessData(id: number) {
    this.router.navigate(['menuMapping'], { "queryParams": { "id": id, 'registerToken': this.registerToken }, relativeTo: this.route, skipLocationChange: true });
  }

  ngOnDestroy() {
    this.dtTrigger?.unsubscribe();
  }

  openNewRequest(){
    this.router.navigate(['/registeruser/register'], { queryParams: {'registerToken': this.registerToken } });
  }
}
